import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import AppraisalSurchargesTable from '../AppraisalSurchargesTable';

import {
  captionStyles,
  getCardStyles,
  labelIconStyles,
  labelIconWrapperStyles,
  labelWrapperStyles,
  wrapperStyles,
} from './AppraisalSurchargesCard.styles';

const AppraisalSurchargesCard = ({ surcharges, isFieldChanged = false }) => (
  <Box sx={wrapperStyles}>
    <Box sx={getCardStyles({ isFieldChanged })}>
      <Box sx={labelWrapperStyles}>
        <Box sx={labelIconWrapperStyles}>
          <Box component={InfoIcon} size={IconSize[24]} sx={labelIconStyles} />
        </Box>
        <Typography component="h5" variant="bold16">
          Appraisal Surcharges
        </Typography>
      </Box>

      <Typography color="text.dark" component="p" sx={captionStyles} variant="regular12">
        Applied automatically from this company&apos;s appraisal surcharge rules.
      </Typography>

      <AppraisalSurchargesTable surcharges={surcharges} />
    </Box>
  </Box>
);

AppraisalSurchargesCard.propTypes = {
  surcharges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      amount: PropTypes.number,
    }),
  ).isRequired,
  isFieldChanged: PropTypes.bool,
};

export default memo(AppraisalSurchargesCard);
